import { isFirstDayOfMonth, parse, startOfDay } from "date-fns";

export const isProRataDate = (date: string): boolean => {
  try {
    const formattedDate = startOfDay(parse(date, "yyyy-MM-dd", new Date()));
    return !!date && !isFirstDayOfMonth(formattedDate);
  } catch (error) {
    console.error("Invalid date format:", error);
    return false;
  }
};
